import classNames from "classnames";
import round from "lodash/round";
import React, { FunctionComponent, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import ProgressBar from "../../../../components/atoms/ProgressBar";
import BaseUploadProvider from "../../../../providers/upload/BaseUploadProvider";
import "./style.scss";

const SelectionUploadSummary: FunctionComponent<{
  forcedDisplay?: boolean;
  uploadProvider: BaseUploadProvider;
}> = ({ forcedDisplay = false, uploadProvider }) => {
  const [animated, setAnimated] = useState<boolean>(false);
  const [displayed, setDisplayed] = useState<boolean>(forcedDisplay);
  const [progress, setProgress] = useState<number>(0);
  const intl = useIntl();

  useEffect(() => {
    setDisplayed(forcedDisplay);
  }, [setDisplayed, forcedDisplay]);

  useEffect(() => {
    let isStillSubscribed = true;

    return uploadProvider.onTick(() => {
      if (!isStillSubscribed) {
        return;
      }

      const queueSize = uploadProvider.count();
      const finishedSize = uploadProvider.count("finished");
      if (queueSize > 0) {
        setProgress(round((100 * finishedSize) / queueSize));
        setAnimated(true);
        setDisplayed(true);
      } else {
        setProgress(100);
        setAnimated(false);
        setTimeout(() => {
          if (isStillSubscribed) {
            setDisplayed(false);
            setTimeout(() => {
              if (isStillSubscribed) {
                setProgress(0);
              }
            }, 1000);
          }
        }, 2000);
      }

      return () => {
        isStillSubscribed = false;
      };
    });
  }, [setAnimated, setDisplayed, setProgress, uploadProvider]);

  return (
    <div
      className={classNames("SelectionUploadSummary", {
        "SelectionUploadSummary--hidden": !displayed,
      })}
    >
      <ProgressBar percent={progress} animated={animated} />
      {displayed && progress < 1 && (
        <div className="SelectionUploadSummary-text">
          {intl.formatMessage({ id: "kustom_SelectionUploadSummary_loading" })}
        </div>
      )}
    </div>
  );
};

export default SelectionUploadSummary;
